import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=3160a67e&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports